import _ from 'lodash';

const isFiltered = (state) =>{
  return !(state.search==='')
}

function createFilter(queryString) {
  return (provider) => {
    return (_.deburr(provider.name.toLowerCase()).indexOf(_.deburr(queryString).toLowerCase()) === 0);
  };
}

const getFilteredCMSProviders = (state) => {
  return state.search ? state.cmsProviders.filter(createFilter(state.search)) : state.cmsProviders;
}

export default {
isFiltered,
getFilteredCMSProviders
};
